import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import CovenantComplianceUpdateModalUI from './CovenantComplianceUpdateModalUI';

class CovenantComplianceUpdateModalSF extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false,
      nonComplianceText: '',
      nonComplianceTextError: null,
      remedialActionText: '',
      remedialActionTextError: null,
    };
  }

  render() {
    return (
      <CovenantComplianceUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        nonComplianceText={this.state.nonComplianceText}
        onNonComplianceTextChange={(event) => this.setState({ nonComplianceText: event.target.value })}
        nonComplianceTextError={this.state.nonComplianceTextError}
        setNonComplianceTextError={(error) => this.setState({ nonComplianceTextError: error })}
        //
        remedialActionText={this.state.remedialActionText}
        onRemedialActionTextChange={(event) => this.setState({ remedialActionText: event.target.value })}
        remedialActionTextError={this.state.remedialActionTextError}
        setRemedialActionTextError={(error) => this.setState({ remedialActionTextError: error })}
      />
    );
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  componentDidUpdate(prevProps) {
    let selectedLoanCompliance = this.props.selectedLoanCompliance
    if (!selectedLoanCompliance)
      return
    if (prevProps.selectedLoanCompliance && prevProps.selectedLoanCompliance.legalLanguageCode == selectedLoanCompliance.legalLanguageCode)
      return

    this.setState({
      nonComplianceText: selectedLoanCompliance.nonComplianceText,
      remedialActionText: selectedLoanCompliance.remedialActionText,
    })
  }

  onSubmit = () => {
    if (this.state.submitted) return;

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    });


    RestApiUtils.put(
      this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances/v1/${this.props.selectedLoanCompliance.legalLanguageCode}/covenantUpdate`,
      this.onSubmitCallback, {
      nonComplianceText: this.state.nonComplianceText,
      remedialActionText: this.state.remedialActionText,
    }
    );
  };

  onSubmitCallback = (response) => {
    let errorList = [];
    if (response && response.errorList) {
      errorList = response.errorList.map(error => error.message);
    }

    this.setState({
      successMsg: response.success,
      errorList,
      submitted: false,
    });

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null });
        this.props.onCancelClick();
        this.props.onRefreshClick();
      }, 2000);
    }
  };

  setErrorList = (errorList) => {
    this.setState({ errorList });
  };
}

export default withRouter(CovenantComplianceUpdateModalSF);
